/**
 * Created by user on 2018/3/30/030.
 */
export {
	IPlatformPathNodeOrigin as PlatformPath,

	IPathPlatformOrigin,
	IPathPlatform,

	ORIGIN_KEY,

	IParse,

	IPathType,
	IPathNode,
	IPath,

} from '@lazy-node/types-path';
